export const LANGUAGES = [
	{ key: 'en', value: 'English (US)' },
	{ key: 'zh-TW', value: '中文 (繁體)' },
	{ key: 'zh-CN', value: '中文 (简体)' },
	{ key: 'it', value: 'Italiano (IT)' },
	{ key: 'de', value: 'Deutsch (DE)' },
	{ key: 'ja', value: '日本 (JP)' },
	{ key: 'th', value: 'ไทย (TH)' },
];

export const USER_ROLES = [
	{ key: 'system_admin', value: 'System Admin' },
	{ key: 'reseller', value: 'Reseller' },
	{ key: 'super_admin', value: 'Super Admin' },
	{ key: 'supplier', value: 'Supplier' },
	{ key: 'translator', value: 'Translator' },
];

export const SYSTEM_ADMIN = 'system_admin';
export const RESELLER = 'reseller';
export const SUPER_ADMIN = 'super_admin';
export const SUPPLIER = 'supplier';
export const TRANSLATOR = 'translator';

export const COMPANY_LEVELS = [
	{ key: 'parent', value: 'Parent' },
	{ key: 'hq', value: 'HQ' },
	{ key: 'subsidiary', value: 'Subsidiary' },
];

export const PREVIOUS_BTN = {
	key: 'previous',
	value: 'Previous',
};

export const NEXT_BTN = {
	key: 'next',
	value: 'Next',
};

// company profile
export const COMPANY_PROFILE = {
	COMPANY_PROFILE_TITLE: 'Company Profile',
	COMPANY_NAME: 'Company Name',
	ENTER_COMPANY_NAME: 'Enter Company Name',
	COMPANY_ADDRESS: 'Company Address',
	ENTER_COMPANY_ADDRESS: 'Enter Company Address',
	LOCATION: 'Location',
	SELECT_LOCATION: 'Select Location',
	BUSINESS_NO: 'Business No.',
	ENTER_BUSINESS_NO: 'Enter Business No.',
	COMPANY_TYPE: 'Company Type',
	ENTER_COMPANY_TYPE: 'Enter Company Type',
	INDUSTRY_SECTOR: 'Industry Sector',
	ENTER_INDUSTRY_SECTOR: 'Enter Industry Sector',
};

export const GET_ROUTE_LIST_BY_RESELLER = [
	'/companies',
	'/onboard',
	'/ghg-source',
	'/emission-activities',
	'/reduction-directions',
	'/report-declaration',
	'/cnp',
	'/currencies',
	'/external-support',
	'/data-collection',
];
